import { memo, ReactElement, useMemo } from 'react';

// eslint-disable-next-line import/no-unresolved
import { isEmpty } from 'lodash';

import styled from '@emotion/styled';

import ShowMoreSlideItem from './ShowMoreSlideItem';
import MainSwiper from '../../shared/MainSwiper';

const Swiper = styled(MainSwiper)`
  .swiper {
    margin-right: -9px;
  }
`;

interface Props {
  items: ReactElement[];
  slidesPerView: number;
  slideAsGroup: boolean;
  landingUrl?: string;
  hadleSelectMore(): void;
}

function ListSwiper({
  items, slidesPerView, landingUrl, hadleSelectMore,
}: Props) {
  const slideItems = useMemo(() => {
    const sliced = items.slice(0, 20);

    if (landingUrl) {
      sliced.push(<ShowMoreSlideItem landingUrl={landingUrl} onSelectMore={hadleSelectMore}/>);
    }

    return sliced;
  }, [hadleSelectMore, items, landingUrl]);

  if (isEmpty(slideItems)) {
    return null;
  }

  return (
    <Swiper
      items={slideItems}
      slidesPerView={slidesPerView}
      buttonOffset={50}
    />
  );
}

export default memo(ListSwiper);
